import type { SectionProps } from "../types";
import { solutions } from "../data";

export default function SolutionsSection({ isVisible, sectionRef }: SectionProps) {
  return (
    <section
      ref={sectionRef}
      data-section="solutions"
      className="py-16 sm:py-20 bg-white overflow-hidden"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-8 sm:gap-10 lg:gap-12 items-center">
          {/* Left: Testimonial Card with Phone Mockup */}
          <div
            className={`transition-all duration-1000 mb-8 lg:mb-0 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <div className="bg-gradient-to-br from-[#0f1f3d] to-[#1a2d4a] rounded-2xl sm:rounded-3xl p-6 sm:p-8 md:p-12 relative overflow-hidden">
              <div className="absolute top-4 right-4 sm:top-8 sm:right-8 opacity-10">
                <div className="w-24 h-24 sm:w-32 sm:h-32 md:w-40 md:h-40 border-2 sm:border-4 border-white rounded-2xl sm:rounded-3xl"></div>
              </div>

              {/* Phone Mockup */}
              <div className="relative mb-6 sm:mb-8">
                <div className="w-40 h-72 sm:w-48 sm:h-80 md:w-52 md:h-96 mx-auto bg-[#0a1628] rounded-2xl sm:rounded-3xl border-2 sm:border-4 border-gray-700 shadow-2xl flex items-center justify-center p-4 sm:p-6 md:p-8">
                  <div className="text-center w-full">
                    <div className="text-cyan-400 text-[10px] sm:text-xs font-bold tracking-wider mb-3 sm:mb-4 uppercase border border-cyan-400/30 rounded-full px-3 py-1 sm:px-4 sm:py-1.5 inline-block">
                      Mentorship Work
                    </div>
                    <div className="space-y-1.5 sm:space-y-2 text-left px-2 sm:px-0">
                      <div className="h-1.5 sm:h-2 bg-cyan-400/30 rounded w-3/4"></div>
                      <div className="h-1.5 sm:h-2 bg-cyan-400/20 rounded w-full"></div>
                      <div className="h-1.5 sm:h-2 bg-cyan-400/20 rounded w-5/6"></div>
                      <div className="h-6 sm:h-8"></div>
                      <div className="h-1.5 sm:h-2 bg-cyan-400/30 rounded w-2/3"></div>
                      <div className="h-1.5 sm:h-2 bg-cyan-400/20 rounded w-4/5"></div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Testimonial */}
              <div className="bg-white/10 backdrop-blur-sm rounded-xl sm:rounded-2xl p-4 sm:p-5 md:p-6">
                <p className="text-white text-xs sm:text-sm md:text-base italic mb-3 sm:mb-4 leading-relaxed">
                  "Dự án cuối khóa của tôi đã giúp tôi nhận được 3 lời mời làm việc
                  ngay lập tức."
                </p>
                <div className="flex items-center gap-2 sm:gap-3">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-cyan-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-user-line text-white text-lg sm:text-xl"></i>
                  </div>
                  <div>
                    <div className="text-white font-bold text-sm sm:text-base">Thành Công</div>
                    <div className="text-white/70 text-xs sm:text-sm">Software Engineer</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Right: Solution Content */}
          <div
            className={`transition-all duration-1000 ${
              isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"
            }`}
          >
            <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#0f1f3d] mb-2 sm:mb-3">
              Giải pháp Stackway:
            </h2>
            <h3 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-bold text-[#2a4b7c] mb-4 sm:mb-5 md:mb-6">
              Lấy dự án làm trung tâm
            </h3>
            <p className="text-gray-600 text-sm sm:text-base mb-6 sm:mb-8 leading-relaxed">
              Chúng tôi không tạo ra người học công cụ. Chúng tôi đào tạo kỹ sư có
              tư duy và năng lực giải quyết vấn đề.
            </p>

            <div className="space-y-4 sm:space-y-5 md:space-y-6">
              {solutions.map((solution, index) => (
                <div key={index} className="flex items-start gap-3 sm:gap-4">
                  <div className="flex-shrink-0 mt-0.5 sm:mt-1">
                    <i className="ri-checkbox-circle-fill text-cyan-500 text-xl sm:text-2xl"></i>
                  </div>
                  <div>
                    <h4 className="text-base sm:text-lg font-bold text-[#2a4b7c] mb-1">
                      {solution.title}
                    </h4>
                    <p className="text-gray-600 text-xs sm:text-sm leading-relaxed">
                      {solution.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

